import { allRolesList } from '@/lib/constants/securityRoles'

function getRoleLabel (key) {
  if (typeof key === 'string') {
    const role = allRolesList.find(sr => sr.name === key)
    return (role ? role.label : null)
  } else if (Array.isArray(key)) {
    let result = ''
    for (let value of key) {
      const role = allRolesList.find(sr => sr.name === value)
      result += (role ? role.label : null) + ', '
    }
    return result.substring(0, result.length - 2)
  } else {
    return null
  }
}

export default getRoleLabel
